// KM division badge colors — presentation helper extracted verbatim from the
// monolith (legacy/App.tsx). Division-badge color per letter (A/B/C…), following
// the ELO-level palette (A = strongest red → E = purple), used consistently
// across all KM tabs to mark which division a match/pair/group belongs to.
//
// The letter is white, 9 px, so every entry reaches 4.5:1 under white (#1144,
// owner decision 2026-11-02): B was #ea580c (3.56:1) and C #65a30d (3.09:1);
// each is now the AA shade of the same hue. KMCalendarView and
// KMAllGroupsOverview keep their own copies of this list, with the same values.
export const KM_DIV_BADGE_COLORS = [
  '#dc2626',
  '#cc4c0a',
  '#508307',
  '#1e293b',
  '#7c3aed',
  '#64748b',
];

export function kmDivBadgeColor(divName?: string | null): string {
  const name = (divName || 'A').toString();
  const idx = /^[A-Z]$/i.test(name) ? name.toUpperCase().charCodeAt(0) - 65 : 0;
  return KM_DIV_BADGE_COLORS[idx % KM_DIV_BADGE_COLORS.length];
}
